// import this after install `@mdi/font` package
import "@mdi/font/css/materialdesignicons.css";

import "vuetify/styles";
import { createVuetify } from "vuetify";

import { tr } from "vuetify/locale";

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    // ... your configuration
    // Translations provided by Vuetify
    locale: {
      locale: "tr",
      fallback: "tr",
      messages: { tr },
    },
  });
  app.vueApp.use(vuetify);
});
